import { AgGridColumn } from 'ag-grid-react/lib/agGridColumn';
import React from 'react';
import { useSelector } from 'react-redux';

import { featureGridColumnsSelector, generalColumnDefinition, getFeatureGridColumnProps } from '../../utils';
import { OrganizationAddress, useCaseMangerContactQuery } from '../../graphql';
import { ConnectedHcpGridWithGQL } from '../HcpGridWithGQL';
import { AppRootState } from '../../redux/reducers';
import { HcpGridDummayData } from './HcpGridDummyData';
import { AnyType } from '../../interfaces';

const columnSelector = featureGridColumnsSelector('resources.contact-info.care-coordinator.table');
const PRIMARY = 1;

export const CareCoordinatorTable = () => {
  const columns = useSelector(columnSelector);
  let zipCode = useSelector((state: AppRootState) => state.auth.session?.userInfo?.zip);
  const orgAddresses: OrganizationAddress | AnyType = useSelector(
    (state: AppRootState) => state.auth.session?.orgDetails?.organizationAddresses
  );
  if ((!zipCode || zipCode?.length <= 0) && orgAddresses && orgAddresses?.length > 0) {
    zipCode = orgAddresses?.find((orgAdd: OrganizationAddress) => PRIMARY === orgAdd?.rank)?.zip;
  }

  const queryOptions = {
    variables: {
      zip: zipCode
    }
  };

  if (!columns) return null;

  return (
    <>
      {!zipCode || zipCode?.length <= 0 ? (
        <HcpGridDummayData data={[]} pagination>
          <AgGridColumn
            {...generalColumnDefinition()}
            resizable={false}
            field='name'
            {...getFeatureGridColumnProps(columns?.name)}
          />
          <AgGridColumn
            {...generalColumnDefinition()}
            resizable={false}
            field='email'
            {...getFeatureGridColumnProps(columns?.email)}
          />
          <AgGridColumn
            {...generalColumnDefinition()}
            resizable={false}
            field='phoneNumber'
            {...getFeatureGridColumnProps(columns?.phone)}
          />
        </HcpGridDummayData>
      ) : (
        <ConnectedHcpGridWithGQL queryHook={useCaseMangerContactQuery} queryOptions={queryOptions} pagination>
          <AgGridColumn
            {...generalColumnDefinition()}
            resizable={true}
            field='name'
            {...getFeatureGridColumnProps(columns?.name)}
          />
          <AgGridColumn
            {...generalColumnDefinition()}
            resizable={true}
            field='email'
            {...getFeatureGridColumnProps(columns?.email)}
          />
          <AgGridColumn
            {...generalColumnDefinition()}
            resizable={true}
            field='phoneNumber'
            {...getFeatureGridColumnProps(columns?.phone)}
          />
        </ConnectedHcpGridWithGQL>
      )}
    </>
  );
};
